<template>
  <nav>
    <v-navigation-drawer
      app
      floating
      v-if="$store.getters.loggedIn"
      :permanent="$vuetify.breakpoint.mdAndUp"
      :expand-on-hover="$vuetify.breakpoint.mdAndUp"
      v-model="$store.state.APP.DRAWER_MENU"
      mini-variant-width="70"
      style="z-index: 8;max-height: 100%;"
      right
    >
      <v-list>
        <v-list-item link @click="userDialog = true" two-line>
          <v-list-item-avatar>
            <v-img
              :src="
                $store.state.MEDIA.USER_IMAGE[0] === 'd'
                  ? $store.state.MEDIA.USER_IMAGE
                  : $store.state.MEDIA.USER_IMAGE +
                    '?' +
                    Math.round(Math.random() * 1000)
              "
            ></v-img>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{ user }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-list nav dense>
        <v-list-item style="margin-bottom:-20px;">
          <v-list-item-icon style="height:56px;"> </v-list-item-icon>

          <v-list-item-content>
            <v-subheader style="margin-left:20px;">inställningar</v-subheader>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>

        <v-list-item
          link
          @click="showMe = !showMe"
          router
          :to="'/' + $store.state.STYLE.PATH"
        >
          <v-list-item-icon>
            <v-icon>mdi-monitor-cellphone</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
              Min Sida
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link router :to="'/my_shop'">
          <v-list-item-icon>
            <v-icon>mdi-cart</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Min Shop</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-group :prepend-icon="'mdi-group'" no-action>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Overlays</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item link to="/donation_overlays">
            <v-list-item-content>
              <v-list-item-title>Donationer</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/video_alert">
            <v-list-item-content>
              <v-list-item-title
                >Video<span style="font-size:10px;color:#00a439;"
                  ><b style="margin-left:4px;">Nyhet!</b></span
                ></v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>

          <v-list-item disabled link to="/spons_overlays">
            <v-list-item-content>
              <v-list-item-title
                >Spons
                <span style="font-size:10px;"
                  ><b>beta</b></span
                ></v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-item link router :to="'/alerts'">
          <v-list-item-icon>
            <v-icon>mdi-chat-alert</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Alerts</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link router :to="'/payments'">
          <v-list-item-icon>
            <v-icon>mdi-cash-multiple</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Utbetalningar</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link router :to="'/logg'">
          <v-list-item-icon>
            <v-icon>mdi-playlist-play</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Logg</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <template v-slot:append>
        <v-list>
          <v-list-item
            v-if="$store.state.STREAMER.IS_ADMIN"
            link
            router
            :to="'/admin'"
          >
            <v-list-item-icon>
              <v-img
                height="18"
                width="24"
                :src="require('../assets/pepega.png')"
              ></v-img>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Admin</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            v-if="$store.getters.loggedIn"
            @click="$store.state.APP.SHOW_LOGOUT = true"
            text
            color="grey"
          >
            <v-list-item-icon>
              <v-icon>exit_to_app</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Logga ut</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>
    </v-navigation-drawer>
    <v-dialog v-model="userDialog" max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">Profil</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="3"></v-col>
              <v-col cols="6">
                <v-img
                  :src="
                    $store.state.MEDIA.USER_IMAGE[0] === 'd'
                      ? $store.state.MEDIA.USER_IMAGE
                      : $store.state.MEDIA.USER_IMAGE +
                        '?' +
                        Math.round(Math.random() * 1000)
                  "
                ></v-img>
                <v-btn class="mx-auto" block v-on:click="updateImage" small
                  >Byt profilbild</v-btn
                >
              </v-col>
              <v-col cols="3"></v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  class="centered-input"
                  hide-details
                  @input="setEmail"
                  :value="$store.state.STREAMER.EMAIL"
                  label="Email"
                ></v-text-field>
                <p style="text-align: center;">
                  <small style="text-align: center;"
                    >endast tillgänglig för oss på Hihat
                  </small>
                </p>
              </v-col>
            </v-row>

            <v-row align="center" justify="center">
              <v-col cols="12" style="text-align: center;">
                <v-btn
                  v-if="$store.state.STREAMER.TWITCH_NAME === null"
                  @click="linkTwitch"
                  class="mx-auto"
                  color="deep-purple darken-1"
                  text
                >
                  Anslut till Twitch<v-icon right>mdi-twitch</v-icon>
                </v-btn>
                <v-btn v-else class="mx-auto" color="deep-purple darken-1" text>
                  <v-icon small>mdi mdi-checkbox-marked-circle-outline</v-icon
                  >{{ $store.state.STREAMER.TWITCH_NAME
                  }}<v-icon right>mdi-twitch</v-icon>
                </v-btn>

                <p>
                  <small
                    >Genom att ansluta ditt Hihat-konto till ett Twitch-konto,
                    kan du b.la. logga in på Hihat genom Twitch.</small
                  >
                </p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn
            class="mx-auto"
            color="red darken-1"
            text
            @click="deleteDialog = true"
            >Radera Hihat-konto</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteDialog" max-width="290">
      <v-card>
        <v-card-title class="headline">Radera konto</v-card-title>

        <v-card-text>
          {{ user }}, innan du går:
          <br />
          Vad kunde vi ha gjort bättre?
          <v-textarea
            name="input-7-4"
            label="Feedback"
            v-model="reason"
          ></v-textarea>
        </v-card-text>

        <v-card-actions>
          <v-btn color="red" class="white--text mx-auto" @click="deleteAccount">
            RADERA KONTO
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <input
      id="imageInput"
      style="display:none;"
      type="file"
      accept="image/*"
      v-on:change="openFile"
    />
    <v-dialog
      content-class="elevation-0"
      v-model="noteDialog"
      width="auto"
      height="auto"
      persistent
    >
      <v-card v-if="note" outlined class="mx-auto" max-width="500">
        <v-card-title>{{ note.TITLE }}</v-card-title>
        <v-card-text>
          {{ note.MESSAGE }}
        </v-card-text>
        <v-card-actions>
          <v-btn outlined :loading="noteLoading" block @click="noteReceived">
            {{ note.ACTION }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </nav>
</template>

<script>
export default {
  props: ["scroll_position"],
  data() {
    return {
      image_hover: false,
      userDialog: false,
      deleteDialog: false,
      noteDialog: false,
      noteLoading: false,

      note: null,
      items: [
        { icon: "mdi-cart", text: "Hihat Shop", route: "/my_shop" },
        { icon: "mdi-group", text: "Overlays", route: "/overlays" },
        { icon: "mdi-chat-alert", text: "Alerts", route: "/alerts" },
        {
          icon: "mdi-cash-multiple",
          text: "Utbetalningar",
          route: "/payments",
        },
        { icon: "mdi-playlist-play", text: "Logg", route: "/logg" },
      ],
      showMe: false,
      reason: "",
      updateUser: null,
      is_beauty: false,
      admins: [
        ["Management", "people_outline"],
        ["Settings", "settings"],
      ],
      cruds: [
        ["Create", "add"],
        ["Read", "insert_drive_file"],
        ["Update", "update"],
        ["Delete", "delete"],
      ],
    };
  },
  computed: {
    isBig: function() {
      return this.$vuetify.breakpoint.mdAndUp;
    },
    isPage: function() {
      return this.$route.name === "MyPage.vue";
    },

    user: function() {
      let full = this.$store.state.STREAMER.USER_NAME;
      if (full.length > 18) {
        return full.substring(0, 17) + "..";
      } else {
        return full;
      }
    },
  },
  mounted: function() {
    this.getNotes();
  },
  methods: {
    deleteAccount: function() {
      let http = new XMLHttpRequest();
      http.withCredentials = true;
      let url = "/api/deleteAccount?";
      let params = "REASON=" + this.reason;
      http.open("POST", url, true);
      let self = this;
      http.setRequestHeader(
        "Content-type",
        "application/x-www-form-urlencoded"
      );

      http.onreadystatechange = function() {
        //Call a function when the state changes.

        if (http.readyState === 4 && http.status > 200) {
          self.$store.commit(
            "update_snackbar",
            "Ett fel inträffade vid raderingen av ditt konto. Hör av dig till oss."
          );
        } else if (http.readyState === 4 && http.status === 200) {
          self.$store.commit("update_snackbar", "Kontot har raderats");
          self.logout();
          self.goHome();
          self.deleteDialog = false;
          self.userDialog = false;
        }
      };
      http.send(params);
    },
    logout: function() {
      let http = new XMLHttpRequest();
      http.withCredentials = true;
      let url = "/api/logout?";
      http.open("GET", url, true);
      http.setRequestHeader(
        "Content-type",
        "application/x-www-form-urlencoded"
      );
      let self = this;
      http.onreadystatechange = function() {
        //Call a function when the state changes.

        if (http.readyState === 4 && http.status > 200) {
          console.log("error");
        } else if (http.readyState === 4 && http.status === 200) {
          self.$store.state.APP.SHOW_LOGIN = false;
          self.$store.state.APP.SHOW_LOGOUT = false;
          self.$store.commit("logout");
        }
      };
      return http.send();
    },
    goHome: function() {
      this.$router.push({ path: "/" });
    },
    noteReceived: function() {
      this.noteLoading = true;
      let http = new XMLHttpRequest();
      http.withCredentials = true;
      let url = "/api/note_received";
      let params = "NID=" + this.note.NID;
      let self = this;
      http.open("POST", url, true);

      http.setRequestHeader(
        "Content-type",
        "application/x-www-form-urlencoded"
      );
      http.onreadystatechange = function() {
        if (http.readyState === 4) {
          const path = self.note.LINKSTO;
          self.noteDialog = false;
          self.note = null;

          self.$router.push({ path: path });
        }
      };
      http.send(params);
    },
    getNotes: function() {
      let http = new XMLHttpRequest();
      http.withCredentials = true;
      let url = "/api/notes";
      http.open("GET", url, true);
      http.setRequestHeader(
        "Content-type",
        "application/x-www-form-urlencoded"
      );
      let self = this;
      http.onreadystatechange = function() {
        //Call a function when the state changes.
        if (http.readyState === 4 && http.status === 200) {
          const data = JSON.parse(http.response);
          if("NID" in data){
            self.note = data;
            self.noteDialog = true;
          }
          
        }
      };
      http.send();
    },
    openFile: function(file) {
      console.log(file);

      let input = file.target;

      let reader = new FileReader();
      let self = this;
      reader.onload = function() {
        //self.$store.state.MEDIA.USER_IMAGE=reader.result;
        self.$store.commit("USER_IMAGE", reader.result);
        self.saveNewImage(reader.result);
      };
      reader.readAsDataURL(input.files[0]);
    },
    updateImage: function() {
      document.getElementById("imageInput").click();
    },
    saveNewImage: function(image) {
      let http = new XMLHttpRequest();
      http.withCredentials = true;
      let url = "/api/save_user_image?";
      let params = "IMAGE=" + image;
      http.open("POST", url, true);

      http.setRequestHeader(
        "Content-type",
        "application/x-www-form-urlencoded"
      );
      http.onreadystatechange = function() {
        if (http.readyState === 4 && http.status !== 200) {
          self.$store.commit(
            "update_snackbar",
            "Bilden är för stor. Testa 512x512 px"
          );
        }
      };
      http.send(params);
    },
    linkTwitch: function() {
      window.location.href = "/api/link_twitch";
    },
    updateUserData: function() {
      let http = new XMLHttpRequest();
      http.withCredentials = true;
      let url = "/api/updateUser?";
      let email = this.$store.state.STREAMER.EMAIL;
      if (email === "" || email === null) {
        email = this.$store.state.STREAMER.FAKE_EMAIL;
      }
      let params =
        "USER_NAME=" + this.$store.state.STREAMER.USER_NAME + "&EMAIL=" + email;
      http.open("POST", url, true);
      http.setRequestHeader(
        "Content-type",
        "application/x-www-form-urlencoded"
      );

      http.send(params);
    },
    setEmail(email_string) {
      this.$store.state.STREAMER.EMAIL = email_string;
      console.log(this.$store.state.STREAMER.EMAIL);
      clearTimeout(this.updateUser);
      let self = this;
      this.updateUser = setTimeout(function() {
        self.updateUserData();
      }, 1000);
    },
  },
  watch: {
    "$store.state.STREAMER.USER_NAME": function(newVal, oldVal) {
      console.log("USER NAME CHANGED");
      clearTimeout(this.updateUser);
      let self = this;
      this.updateUser = setTimeout(function() {
        if (oldVal) {
          self.updateUserData();
        }
      }, 1000);
    },
  },
};
</script>

<style scoped>
.centered-input input {
  text-align: center;
}
.centered-input >>> input {
  text-align: center;
}
</style>
